export const PHONE_REGEX = {
  ES: /^(\+34|0034)([679]\d{8})$/,              // 🇪🇸 Spain: Starts with 6, 7, or 9 (Mobile & Landline)
  FR: /^(\+33|0033)([1-9]\d{8})$/,              // 🇫🇷 France: Starts with 1-9 (Mobile & Landline)
  UK: /^(\+44|0044)(7[1-9]\d{8})$/,             // 🇬🇧 UK: Mobile starts with 71-79, 10-digit length
  PT: /^(\+351|00351)(9[1236]\d{7})$/,          // 🇵🇹 Portugal: Mobile starts with 91, 92, 93, or 96
  DE: /^(\+49|0049)([1-9][0-9]{1,4}\d{6,10})$/, // 🇩🇪 Germany: Area codes 1-9, 6-10 digits
  IT: /^(\+39|0039)(3\d{2}\d{6,7})$/,           // 🇮🇹 Italy: Mobile starts with 3xx, 10-11 digits
  US: /^(\+1|001)([2-9]\d{2}[\s.-]?\d{3}[\s.-]?\d{4})$/, // 🇺🇸 US: 10-digit format, area codes 2-9
}

export const phoneWithInternationalCodePlusFormat = (phoneNumber: string, defaultCountry: keyof typeof PHONE_REGEX = 'ES'): string => {
  if (!phoneNumber) return phoneNumber

  // If number already has +XX or 00XX, return as is
  for (const countryCode in PHONE_REGEX) {
    const regex = PHONE_REGEX[countryCode as keyof typeof PHONE_REGEX]
    if (phoneNumber.match(regex)) {
      return phoneNumber // Already formatted correctly
    }
  }

  // If no international code found, add the default country code
  return `+${PHONE_REGEX[defaultCountry].toString().match(/\d+/)?.[0]}${phoneNumber}`
}


export const phoneWithoutInternationalCode = (phoneNumber: string): string => {
  if (!phoneNumber) return phoneNumber

  for (const countryCode in PHONE_REGEX) {
    const regex = PHONE_REGEX[countryCode as keyof typeof PHONE_REGEX]
    const match = phoneNumber.match(regex)
    if (match) {
      return match[2] // Return the local number without the country code
    }
  }

  return phoneNumber // Return the original if no match is found
}
